import { z } from 'zod';

/**
 * A boolean query-string flag, e.g. `?includeArchived=false`.
 *
 * `z.coerce.boolean()` runs the raw value through `Boolean(...)`, and
 * `Boolean('false')` is `true` — any non-empty string coerces to `true`,
 * including the literal string `"false"` a query param always arrives as.
 * Every endpoint that sends an explicit `false` (not just omitting the
 * flag) needs this instead — `z.coerce.boolean()` silently always shows
 * archived/deleted rows regardless of what the client asked for.
 */
export function queryBoolean() {
  return z
    .union([z.boolean(), z.enum(['true', 'false'])])
    .transform((value) => (typeof value === 'boolean' ? value : value === 'true'));
}
